import React from "react";
import { Stack, CircularProgress } from "@mui/material";

const LoadingSpinner = (props) => {
  return (
    <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
      <CircularProgress size={props.size} sx={props.color ? { color: props.color } : { color: "gray" }} />
    </Stack>
  );
};

export default LoadingSpinner;
